import angular from 'angular'
import angularAnimate from 'angular-animate'
import $ from 'jquery'

export default angular
  .module('adminPanel.animations', [angularAnimate])
  .animation('.slide-show-hide', function() {
    return {
      beforeAddClass: function(element, className, done) {
        if (className === 'ng-hide') {
          $(element).slideUp(done)
        }
      },
      removeClass: function(element, className, done) {
        if (className === 'ng-hide') {
          $(element).css({
            display: 'none'
          })
          $(element).slideDown(done)
        }
      },
      enter: function() {},
      leave: function() {}
    }
  })
  .animation('.fade-show-hide', function() {
    return {
      beforeAddClass: function(element, className, done) {
        if (className === 'ng-hide') {
          $(element).fadeOut(done)
        }
      },
      removeClass: function(element, className, done) {
        if (className === 'ng-hide') {
          $(element).css({
            display: 'none'
          })
          $(element).fadeIn(done)
        }
      }
    }
  })
